'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectVenueId = exports.setStudioClickOpensNewTab = exports.setSnapLocation = exports.setUnsupportedLocation = exports.setVenueScheduleDate = exports.setVenueId = exports.SET_STUDIO_CLICK_OPENS_NEW_TAB = exports.SET_UNSUPPORTED_LOCATION = exports.SET_SNAP_LOCATION = exports.SET_VENUE_SCHEDULE_DATE = exports.SET_VENUE_ID = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

exports.default = reducer;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET_VENUE_ID = exports.SET_VENUE_ID = 'classpass/explore/SET_VENUE_ID';
var SET_VENUE_SCHEDULE_DATE = exports.SET_VENUE_SCHEDULE_DATE = 'classpass/explore/SET_VENUE_SCHEDULE_DATE';
var SET_SNAP_LOCATION = exports.SET_SNAP_LOCATION = 'classpass/explore/SET_SNAP_LOCATION';
var SET_UNSUPPORTED_LOCATION = exports.SET_UNSUPPORTED_LOCATION = 'classpass/explore/SET_UNSUPPORTED_LOCATION';
var SET_STUDIO_CLICK_OPENS_NEW_TAB = exports.SET_STUDIO_CLICK_OPENS_NEW_TAB = 'classpass/explore/SET_STUDIO_CLICK_OPENS_NEW_TAB';

var initialState = {
  snapLocation: '',
  studioClickOpensNewTab: false,
  venueId: 0
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SET_VENUE_ID:
    case SET_VENUE_SCHEDULE_DATE:
    case SET_UNSUPPORTED_LOCATION:
    case SET_SNAP_LOCATION:
    case SET_STUDIO_CLICK_OPENS_NEW_TAB:
      return (0, _extends4.default)({}, state, (0, _defineProperty3.default)({}, action.data.key, action.data.value));
    default:
      return state;
  }
}

var setVenueId = exports.setVenueId = function setVenueId(venueId) {
  return { type: SET_VENUE_ID, data: { key: 'venueId', value: parseInt(venueId, 10) } };
};
var setVenueScheduleDate = exports.setVenueScheduleDate = function setVenueScheduleDate(date) {
  return { type: SET_VENUE_SCHEDULE_DATE, data: { key: 'venueScheduleDate', value: date } };
};
var setUnsupportedLocation = exports.setUnsupportedLocation = function setUnsupportedLocation(flag) {
  return { type: SET_UNSUPPORTED_LOCATION, data: { key: 'unsupportedLocation', value: flag } };
};
var setSnapLocation = exports.setSnapLocation = function setSnapLocation() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return { type: SET_SNAP_LOCATION, data: { key: 'snapLocation', value: args.join(',') } };
};
var setStudioClickOpensNewTab = exports.setStudioClickOpensNewTab = function setStudioClickOpensNewTab(value) {
  return { type: SET_STUDIO_CLICK_OPENS_NEW_TAB, data: { key: 'studioClickOpensNewTab', value: value } };
};

var selectVenueId = exports.selectVenueId = function selectVenueId(state) {
  return state.features.explore.venueId;
};